var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKebabMenu = function SvgKebabMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 .5h24A5.5 5.5 0 0 1 35.5 6v24a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 30V6A5.5 5.5 0 0 1 6 .5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E4E7",
    d: "M6 .5h24A5.5 5.5 0 0 1 35.5 6v24a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 30V6A5.5 5.5 0 0 1 6 .5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33,
    d: "M18 18.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334M18 14a.667.667 0 1 0 0-1.333A.667.667 0 0 0 18 14M18 23.333A.667.667 0 1 0 18 22a.667.667 0 0 0 0 1.333"
  })));
};
export default SvgKebabMenu;